/** Asks in a row that got no answer before the panel says so (review 0027 C5): six seconds. */
export const SILENT_ASKS = 3;

/** One more ask without an answer, or an answer: what the search panel should know. Pure. */
export function silence(
  asksUnanswered: number,
  answered: boolean,
): { asks: number; unreachable: boolean } {
  const asks = answered ? 0 : asksUnanswered + 1;
  return { asks, unreachable: asks >= SILENT_ASKS };
}
